import { render, staticRenderFns } from "./20.vue?vue&type=template&id=aad7f4f2&scoped=true&"
import script from "./20.vue?vue&type=script&lang=js&"
export * from "./20.vue?vue&type=script&lang=js&"
import style0 from "./20.vue?vue&type=style&index=0&id=aad7f4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad7f4f2",
  null
  
)

export default component.exports